import Vue from 'vue'
import store from '../store/index.js'

const HOTEL_MERCHANT = 'hotel'

function storeSession(res) {
  store.dispatch('setToken', {
    access: res.access_token,
    refresh: res.refresh_token
  })
  store.dispatch('setUser', res.user)
  store.dispatch('setForgotPassword', '')
}

/*
 * Hotels need the active reservation resolved before the page underneath re-renders,
 * otherwise isReservationActive() reads stale. A failure here must not strand the
 * caller — $getReservationFromAuth rejects with a message and has no catch of its own.
 */
function loadActiveReservation() {
  if (store.getters.getMerchant.merchant_type !== HOTEL_MERCHANT) return Promise.resolve()
  if (store.getters.isReservationActive) return Promise.resolve()

  return Vue.prototype.$getReservationFromAuth().then(function (reservations) {
    if (!reservations || reservations.length === 0) return
    const reservation = reservations[0]
    store.commit('setReservationActive', [
      { key: 'booking_number', value: reservation.booking_number },
      { key: 'detail_id', value: reservation.pms_detail_id },
      { key: 'folio', value: reservation.folio_number },
      { key: 'user_id', value: reservation.guest_profile.user }
    ])
  }).catch(function () {
    /* reservation lookup is best-effort; the session is already valid */
  })
}

/**
 * Applies a successful auth response: tokens, user, and the hotel reservation lookup.
 * @param {object} res response body carrying access_token / refresh_token / user
 * @returns {Promise<void>}
 */
export function applyAuthSuccess(res) {
  storeSession(res)
  return loadActiveReservation()
}

/**
 * Register additionally reports a Lead conversion.
 * @param {object} res response body
 * @param {object} payload the registration payload sent to the API
 * @returns {Promise<void>}
 */
export function applyRegisterSuccess(res, payload) {
  return applyAuthSuccess(res).then(function () {
    Vue.prototype.$sendEventMetaConversionsAPI('Lead', payload)
  })
}



// WEBPACK FOOTER //
// ./src/utils/authSession.js